import axios from 'axios';

const defaultConfig = {
  // baseURL: 'http://localhost:1337',
  // baseURL: 'http://192.168.3.4:1337',
  // baseURL: 'https://sbapi.aplikacii.info',
  baseURL: 'https://merkur.re4m.com',
  // baseURL: 'http://re4m.duckdns.org:1338',
  // baseURL: process.env.API_URL,
  timeout: 15000,
  withCredentials: true,
};

var instance = null;

export const initializeAxios = config => {
  instance = axios.create(Object.assign(defaultConfig, config));
};

const getAxiosInstance = () => {
  if (!instance) {
    initializeAxios();
  }
  return instance;
};

export default getAxiosInstance;
